import React from "react";
import { FaPhone, FaUserMd } from "react-icons/fa";
import { CustomDropdown, CustomTextInput } from "../../../../components";

const EmergencyContact = ({
  formData,
  errors,
  handleInputChange,
  handleDropdownChange,
  handleMobileChange,
  handleNumericInput,
  relationTypeOptions,
  styles,
  translations,
}) => {
  return (
    <>
      {/* ==================== EMERGENCY CONTACT 1 ==================== */}
      <div className={styles.header}>
        <div className={styles.headerIcon}>
          <FaPhone />
        </div>
        <h1 className={styles.headerTitle}>
          {translations.labels?.emergencyContactNumber1 ||
            "Emergency Contact 1"}
        </h1>
      </div>

      <div className="row">
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.firstName || "First Name"}
            name="emergency1FirstName"
            type="text"
            value={formData.emergency1FirstName}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.firstNamePlaceholder || "Enter First Name"
            }
            required
            error={errors.emergency1FirstName}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.middleName || "Middle Name"}
            name="emergency1MiddleName"
            type="text"
            value={formData.emergency1MiddleName}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.middleNamePlaceholder || "Enter Middle Name"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.lastName || "Last Name"}
            name="emergency1LastName"
            type="text"
            value={formData.emergency1LastName}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.lastNamePlaceholder || "Enter Last Name"
            }
            required
            error={errors.emergency1LastName}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.emailAddress || "Email Address"}
            name="emergency1Email"
            type="email"
            value={formData.emergency1Email}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.emailAddressPlaceholder ||
              "Enter Email Address"
            }
            required
            error={errors.emergency1Email}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.phoneNumber || "Phone Number"}
            name="emergency1Phone"
            type="text"
            value={formData.emergency1Phone}
            onChange={(e) => handleNumericInput(e, "emergency1Phone", 10)}
            placeholder={
              translations.labels?.phoneNumberPlaceholder ||
              "Enter Phone Number"
            }
            maxLength={10}
            required
            error={errors.emergency1Phone}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomDropdown
            label={translations.labels?.relationType || "Relation Type"}
            name="emergency1RelationType"
            value={formData.emergency1RelationType}
            onChange={(value) =>
              handleDropdownChange("emergency1RelationType", value)
            }
            options={relationTypeOptions}
            placeholder={
              translations.labels?.selectRelation || "Select Relation"
            }
            required
            error={errors.emergency1RelationType}
          />
        </div>
      </div>

      {/* ==================== EMERGENCY CONTACT 2 ==================== */}
      <div className={styles.header}>
        <div className={styles.headerIcon}>
          <FaPhone />
        </div>
        <h1 className={styles.headerTitle}>
          {translations.labels?.emergencyContactNumber2 ||
            "Emergency Contact 2"}
        </h1>
      </div>

      <div className="row">
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.firstName || "First Name"}
            name="emergency2FirstName"
            type="text"
            value={formData.emergency2FirstName}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.firstNamePlaceholder || "Enter First Name"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.middleName || "Middle Name"}
            name="emergency2MiddleName"
            type="text"
            value={formData.emergency2MiddleName}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.middleNamePlaceholder || "Enter Middle Name"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.lastName || "Last Name"}
            name="emergency2LastName"
            type="text"
            value={formData.emergency2LastName}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.lastNamePlaceholder || "Enter Last Name"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.emailAddress || "Email Address"}
            name="emergency2Email"
            type="email"
            value={formData.emergency2Email}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.emailAltPlaceholder || "Enter Email Address"
            }
            error={errors.emergency2Email}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.phoneNumber || "Phone Number"}
            name="emergency2Phone"
            type="text"
            value={formData.emergency2Phone}
            onChange={(e) => handleNumericInput(e, "emergency2Phone", 10)}
            placeholder={
              translations.labels?.phoneNoPlaceholder || "Enter Phone Number"
            }
            maxLength={10}
            error={errors.emergency2Phone}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomDropdown
            label={translations.labels?.relationType || "Relation Type"}
            name="emergency2RelationType"
            value={formData.emergency2RelationType}
            onChange={(value) =>
              handleDropdownChange("emergency2RelationType", value)
            }
            options={relationTypeOptions}
            placeholder={
              translations.labels?.selectRelation || "Select Relation"
            }
          />
        </div>
      </div>

      {/* ==================== FAMILY DOCTOR ==================== */}
      <div className={styles.header}>
        <div className={styles.headerIcon}>
          <FaUserMd />
        </div>
        <h1 className={styles.headerTitle}>
          {translations.labels?.familyDoctor || "Family Doctor"}
        </h1>
      </div>

      <div className="row">
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.firstName || "First Name"}
            name="doctorFirstName"
            type="text"
            value={formData.doctorFirstName}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.firstNamePlaceholder || "Enter First Name"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.middleName || "Middle Name"}
            name="doctorMiddleName"
            type="text"
            value={formData.doctorMiddleName}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.middleNamePlaceholder || "Enter Middle Name"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.lastName || "Last Name"}
            name="doctorLastName"
            type="text"
            value={formData.doctorLastName}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.lastNamePlaceholder || "Enter Last Name"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.emailAddress || "Email Address"}
            name="doctorEmail"
            type="email"
            value={formData.doctorEmail}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.emailAddressPlaceholder ||
              "Enter Email Address"
            }
            error={errors.doctorEmail}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.phoneNumber || "Phone Number"}
            name="doctorPhone"
            type="text"
            inputClassName={styles.markInput}
            value={formData.doctorPhone}
            onChange={(e) => handleNumericInput(e, "doctorPhone", 10)}
            placeholder={
              translations.labels?.phoneNumberPlaceholder ||
              "Enter Phone Number"
            }
            maxLength={10}
            error={errors.doctorPhone}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.hospital || "Hospital"}
            name="doctorHospital"
            type="text"
            value={formData.doctorHospital}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.hospitalPlaceholder || "Enter Hospital Name"
            }
          />
        </div>
      </div>
    </>
  );
};

export default EmergencyContact;
